import { Box, CircularProgress, LinearProgress, Skeleton, Typography } from "@mui/material";

// The app's loading displays (the same set as sFass, drawn with MUI).

export function Spinner({ size = 24 }) {
  return <CircularProgress size={size} thickness={5} sx={{ color: "#127C43" }} />;
}

// A thin bar sliding across, for "something is loading"
export function LoadingBar() {
  return (
    <LinearProgress
      sx={{
        height: 3,
        bgcolor: "rgba(18,124,67,0.15)",
        "& .MuiLinearProgress-bar": { bgcolor: "#127C43" },
      }}
    />
  );
}

// A small "Loading…" line inside a card or table
export function InlineLoading({ label = "Loading…" }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
      <Spinner size={16} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

// A panel-sized placeholder while a section loads
export function LoadingPanel({ label = "Loading…", minHeight = 160 }) {
  return (
    <Box
      sx={{
        minHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
      }}
    >
      <Spinner />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

// Shown while a page's code is opening (Suspense fallback)
export function PageLoading() {
  return (
    <Box>
      <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 2000 }}>
        <LoadingBar />
      </Box>
      <LoadingPanel label="Opening…" minHeight="50vh" />
    </Box>
  );
}

// Grey rows standing in for a table that is loading
export function TableSkeleton({ rows = 6, columns = 5 }) {
  return (
    <Box sx={{ p: 1 }}>
      {Array.from({ length: rows }).map((_, r) => (
        <Box key={r} sx={{ display: "flex", gap: 2, py: 0.75 }}>
          {Array.from({ length: columns }).map((__, c) => (
            <Skeleton key={c} variant="text" sx={{ flex: c === 0 ? 2 : 1 }} />
          ))}
        </Box>
      ))}
    </Box>
  );
}
